import { actionConstants } from '../actions/actionConstants';

const initState = {
  groups: [],
  departments: [],
  roles: [],
  users: [],
  timezones: [],
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.CLEAR_DATA:
      return { ...initState };
    case actionConstants.CLEAR_ERROR:
      return { ...state, errors: '' };
    case actionConstants.LOOKUP_GROUPS_SUCCESS:
      return { ...state, groups: action.data.items };
    case actionConstants.LOOKUP_GROUPS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_DEPARTMENTS_SUCCESS:
      return { ...state, departments: action.data.items };
    case actionConstants.LOOKUP_DEPARTMENTS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_ROLES_SUCCESS:
      return { ...state, roles: action.data.items };
    case actionConstants.LOOKUP_ROLES_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_SUCCESS:
      return { ...state, groups: action.data.items };
    case actionConstants.LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_BR_GROUPS_BY_DEPT_SUCCESS:
      return { ...state, groups: action.data.items };
    case actionConstants.LOOKUP_BR_GROUPS_BY_DEPT_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_USERS_SUCCESS:
      return { ...state, users: action.data.items };
    case actionConstants.LOOKUP_USERS_FAILURE:
      return { ...state, errors: action.data };
    case actionConstants.LOOKUP_TIMEZONES_SUCCESS:
      return { ...state, timezones: action.data.items };
    case actionConstants.LOOKUP_TIMEZONES_FAILURE:
      return { ...state, errors: action.data };
    default:
      return state;
  }
};
